// Types
import { ExperienceStatus } from 'api/graphql-global-types';

type ExperienceWithImages = {
  images:
    | { isMainImage: boolean | null; experienceImageFileKey: string | null }[]
    | null;
};

export const getExperienceHoverImage = (
  experience: ExperienceWithImages | null | undefined
): string | undefined => {
  if (!experience?.images || experience.images.length < 2) return undefined;

  const mainImage = experience.images.find((img) => img.isMainImage)
    ?.experienceImageFileKey;

  const otherImage = experience.images.find(
    (img) =>
      img.experienceImageFileKey && img.experienceImageFileKey !== mainImage
  );

  return otherImage?.experienceImageFileKey ?? undefined;
};

export const renderComment = (status: ExperienceStatus): string => {
  switch (status) {
    case 'Active':
      return 'Item has been listed';
    // Inactive is currently not fetched by BE
    case 'Inactive':
      return 'Item has been removed. You may re-list it from the action column to the right.';
    case 'Sold':
      return 'All the items have been sold';
    default:
      return '';
  }
};

export const numberOfUnits = (
  stock: number | null | undefined
): number | string => {
  if (stock === null) {
    return 'Unlimited';
  } else {
    return stock || 0;
  }
};
